import {forwardRef} from "react";
import {styled} from "@mui/material";
import CustomPattern from "./CustomPattern";

const OuterContainer = styled("div")(({theme}) => ({
    backgroundColor: "white",
    margin: "0px",
}));

interface heightInterface {
    height: number;
}

// const Container = styled('div')<heightInterface>(({theme, height}) => ({
const Container = styled("div")(({theme}) => ({
    boxShadow: "-3px 4px 24px rgba(169, 175, 184, 0.25)",
    borderRadius: theme.shape.borderRadius,
    direction: "rtl",
    // height: height,
    flexDirection: "column",
    justifyContent: "space-between",
    display: "flex",
}));

const FactorPattern = forwardRef(({data, pattern}: { data?: any; pattern: number }, ref) => {
    // @ts-ignore
    const width = ref.current?.getBoundingClientRect().width;
    // const height = width ? width * 297 / 210 : 0
    return (
        // @ts-ignore
        <OuterContainer>
            {/* @ts-ignore */}
            <Container ref={ref}>
                {/* {pattern == 0 && <FirstPattern data={data} />}
                {pattern == 1 && <SecondPattern data={data} />}
                {pattern == 2 && <ThirdPattern data={data} />} */}
                <CustomPattern data={data}/>
            </Container>
        </OuterContainer>
    );
});

export default FactorPattern;
